export const family = {
    title: "Les membres de la famille",
    none: {
        title: "Pas de famille.",
        description: "Oui, mais il doit avoir des amis. J'espère. | Oui, mais elle doit avoir des amis. J'espère. | Oui, mais il doit avoir des amis. J'espère."
    }
}